<template>
	<div>
		<header>
			<h1>Comparisons</h1>
		</header>
		<div>
			<div class="section">
				<loader v-if="!loaded"/>
				<template v-if="loaded">
					<table-filter :filters="filters"/>
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<v-table v-if="items.length" :loading="gettingModels">
						<thead>
							<tr>
								<th align="left">Client</th>
								<th v-if="columns.source" align="left">Source</th>
								<th align="left">Type</th>
								<th align="left">Date</th>
								<th align="center">Leads</th>
								<th align="center">Instructed</th>
								<th align="right" class="actions"><span>Actions</span></th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">Client</th>
								<th v-if="columns.source" align="left">Source</th>
								<th align="left">Type</th>
								<th align="left">Date</th>
								<th align="center">Leads</th>
								<th align="center">Instructed</th>
								<th align="right" class="actions"><span>Actions</span></th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, index) in items">
								<td v-html="$present('clientName', item.client)"/>
								<td v-if="columns.source" v-html="item.serviceProvider.profile.name"/>
								<td v-html="item.type"/>
								<td v-html="$present('dateTime', item.created_at)"/>
								<td align="center" v-html="item.leads.length"/>
								<td align="center">
									<bool-icon :value="item.instructions.length ? true : false"/>
								</td>
								<td align="right">
									<v-contextual>
										<v-contextual-option
											:route-to="{name: 'clients.show', params: {client: item.client.id}}">View</v-contextual-option>
									</v-contextual>
								</td>
							</tr>
						</tbody>
					</v-table>
					<paginator :links="links" :meta="meta"/>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions} = createNamespacedHelpers("comparisons");

export default {

	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"gettingModels",
			"meta",
			"query",
			"filters",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
			"goToPage",
			"paginate",
			"filter",
		]),
	},

	created() {
		this.getModels();
	},
};
</script>
